"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentSubType = void 0;
/**
 * https://seismic.atlassian.net/wiki/spaces/UP/pages/3299016927/Common+Content+Model+v2#Content-Sub-Types-Metadata-Fields
 */
var ContentSubType;
(function (ContentSubType) {
    ContentSubType["Unknown"] = "Unknown";
    /**
     * Clip - Clip (i.e. segment) of a video.
     * [See here for further reading and examples.](https://seismic.atlassian.net/wiki/spaces/UP/pages/3778314261/Clip)
     */
    ContentSubType["Clip"] = "Clip";
})(ContentSubType || (exports.ContentSubType = ContentSubType = {}));
